/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coral_Maple_Lynx_LimpInputs */

const en_coral_maple_lynx_limp = /** @type {(inputs: Coral_Maple_Lynx_LimpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear selection`)
};

const de_coral_maple_lynx_limp = /** @type {(inputs: Coral_Maple_Lynx_LimpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswahl aufheben`)
};

/**
* | output |
* | --- |
* | "Clear selection" |
*
* @param {Coral_Maple_Lynx_LimpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coral_maple_lynx_limp = /** @type {((inputs?: Coral_Maple_Lynx_LimpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coral_Maple_Lynx_LimpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coral_maple_lynx_limp(inputs)
	return de_coral_maple_lynx_limp(inputs)
});